/**
 * 渠道客户用量 API client · 库存日历「渠道视图」
 * 真契约源：apps/api-server/src/api_server/routes/{hotels,attractions,products}.py 末段 usage/monthly
 */
import { api } from "./api";
import type { ChannelUsagePivotRead, UsageModule, UsageMonthlyRead } from "./types/usage";

/** GET /api/v1/hotels/{id}/usage/monthly?year-month=YYYY-MM */
export function getHotelUsageMonthly(id: string, yearMonth: string): Promise<UsageMonthlyRead> {
  return api(`/api/v1/hotels/${id}/usage/monthly?year-month=${yearMonth}`);
}

/** GET /api/v1/attractions/{id}/usage/monthly?year-month=YYYY-MM */
export function getAttractionUsageMonthly(id: string, yearMonth: string): Promise<UsageMonthlyRead> {
  return api(`/api/v1/attractions/${id}/usage/monthly?year-month=${yearMonth}`);
}

/** GET /api/v1/products/{id}/usage/monthly?year-month=YYYY-MM */
export function getProductUsageMonthly(id: string, yearMonth: string): Promise<UsageMonthlyRead> {
  return api(`/api/v1/products/${id}/usage/monthly?year-month=${yearMonth}`);
}

/** GET /api/v1/analytics/channel-usage — 反向透视：行=客户 列=日期（区间 ≤62 天） */
export function getChannelUsagePivot(
  module: UsageModule,
  dateFrom: string,
  dateTo: string,
): Promise<ChannelUsagePivotRead> {
  return api(`/api/v1/analytics/channel-usage?module=${module}&date_from=${dateFrom}&date_to=${dateTo}`);
}
